module.exports = __webpack_public_path__ + "static/img/5098_phase_function_Paper_PointsHejduk_Prediction.42f9b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5098_phase_function_Paper_PointsHejduk_Prediction.png
// module id = BNC2
// module chunks = 0